import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../components-styles/playersGrid.css';
import { mockPlayers } from '../data/mockPlayers';

function PlayersGrid() {
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Simulate API call with mock data
    const loadPlayers = () => {
      try {
        // Use mock data for now
        const sortedPlayers = mockPlayers.slice(0, 6);
        setPlayers(sortedPlayers);
        setError(null);
      } catch (err) {
        console.error('Error loading players:', err);
        setError('Failed to load players');
        setPlayers([]);
      } finally {
        setLoading(false);
      }
    };

    // Simulate network delay
    setTimeout(loadPlayers, 500);
  }, []);

  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return '/default-player.jpg';
    // If it already starts with /, it's a local public file
    if (imageUrl.startsWith('/')) return imageUrl;
    // If it's a full URL, use it as-is
    if (imageUrl.startsWith('http')) return imageUrl;
    // Otherwise, assume it's a backend media URL
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
    return `${apiUrl}${imageUrl}`;
  };

  if (loading) {
    return (
      <section className="players-section">
        <div className="players-container">
          <h2>Our Players</h2>
          <div className="loading">Loading players...</div>
        </div>
      </section>
    );
  }

  if (error || players.length === 0) {
    return null;
  }

  return (
    <section className="players-section">
      <div className="players-container">
        <h2>Our Players</h2>
        <p className="players-intro">Meet some of our represented players across different leagues and positions.</p>
        
        <div className="players-grid">
          {players.map((player) => (
            <Link 
              to={`/player/${player.id}`} 
              key={player.id} 
              className="player-card"
            >
              <div className="player-image-container">
                <img 
                  src={getImageUrl(player.profile_picture)} 
                  alt={`${player.first_name} ${player.last_name}`}
                  className="player-image"
                  onError={(e) => {
                    e.target.src = '/default-player.jpg';
                  }}
                />
              </div>
              <div className="player-info">
                <h3 className="player-name">{player.first_name} {player.last_name}</h3>
                <div className="player-details">
                  {player.nationality?.name && (
                    <p className="player-detail"><strong>Nationality:</strong> {player.nationality.name}</p>
                  )}
                  {player.current_club?.name && (
                    <p className="player-detail"><strong>Club:</strong> {player.current_club.name}</p>
                  )}
                  {player.position && (
                    <p className="player-detail"><strong>Position:</strong> {player.position}</p>
                  )}
                  {player.wing?.name && (
                    <p className="player-detail"><strong>Wing:</strong> {player.wing.name}</p>
                  )}
                </div>
              </div>
              <div className="player-overlay">
                <span className="view-profile">View Profile →</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PlayersGrid;
